<template>
  <v-dialog v-model="discountDialog" :width="400">
      <v-card>
          <my-toolbar title="Apply Discount to All Items"></my-toolbar>
          <v-card-text class="mt-3 mb-n3">
              <v-text-field type="number" label="Enter Discount" v-model="discountText"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn depressed color="primary" outlined @click="discountDialog = false">Cancel</v-btn>
              <v-btn depressed color="primary" @click="handleApply">Apply</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { state, getters } from '@/store/store'
export default {
    data(){
        return{
            discountDialog: false,
            discountText: null
        }
    },
    computed: {
        ...getters, //getParsedResults
    },
    methods:{
        handleDialog(){
            this.discountDialog = !this.discountDialog
        },
        handleApply(){
            if(this.discountText){
                let result = this.getParseResults.invoiceItem.map(item => {
                    let discount = this.discountText;
                    let cost = item.itemCost;
                    let shippedQty = item.shippedQty;

                    let discountedPrice = parseInt(cost) - (parseInt(cost) * 0.08); 
                    let totalPrice = parseInt(shippedQty) * discountedPrice;
                    let discountedPercentage = discount;
                    return {
                        ...item,
                        discountedPrice: discountedPrice.toFixed(2),
                        discountedPercentage,
                        totalPrice: totalPrice.toFixed(2)
                    }
                })

                state.parsedResults = {
                    ...state.parsedResults,
                    invoiceItem: result
                }
                this.discountDialog = false
            }
        }
    }
}
</script>